import { render } from "./TrxMgrApp.vue?vue&type=template&id=e3a3f950"
import script from "./TrxMgrApp.vue?vue&type=script&lang=js"
export * from "./TrxMgrApp.vue?vue&type=script&lang=js"

import "./TrxMgrApp.vue?vue&type=style&index=0&id=e3a3f950&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__